module.exports = __webpack_public_path__ + "static/img/321.03a52392.jpg";